import {
  EyeOpenIcon,
  Pencil1Icon,
  TrashIcon,
  ZoomInIcon,
} from '@radix-ui/react-icons'
import { CantileverButton } from 'components/CantileverButton'
import React from 'react'

import {
  ButtonContainer,
  IconDescription,
  IconRow,
  IconsList,
  SidebarTooltipContainer,
  StyledIcon,
  TooltipArrowLeft,
  TooltipBox,
  TooltipText,
  TooltipTitle,
} from './TutorialStyledComponents'

interface SidebarTooltipProps {
  onPrevious: () => void
  onNext: () => void
}

export const SidebarTooltip: React.FC<SidebarTooltipProps> = ({
  onPrevious,
  onNext,
}) => {
  return (
    <SidebarTooltipContainer>
      <TooltipBox>
        <TooltipArrowLeft />
        <TooltipTitle>Annotations</TooltipTitle>
        <TooltipText>
          Here you can see all the annotations for the model. When you hover
          over an annotation, you&apos;ll see all the action items:
        </TooltipText>
        <IconsList>
          <IconRow>
            <StyledIcon>
              <Pencil1Icon />
            </StyledIcon>
            <IconDescription>Open the annotation editor</IconDescription>
          </IconRow>
          <IconRow>
            <StyledIcon>
              <ZoomInIcon />
            </StyledIcon>
            <IconDescription>View annotation on the model</IconDescription>
          </IconRow>
          <IconRow>
            <StyledIcon>
              <EyeOpenIcon />
            </StyledIcon>
            <IconDescription>Hide or show the annotation</IconDescription>
          </IconRow>
          <IconRow>
            <StyledIcon>
              <TrashIcon />
            </StyledIcon>
            <IconDescription>Delete the annotation</IconDescription>
          </IconRow>
        </IconsList>
        <ButtonContainer>
          <CantileverButton onClick={onPrevious}>Previous</CantileverButton>
          <CantileverButton primary onClick={onNext}>
            Next
          </CantileverButton>
        </ButtonContainer>
      </TooltipBox>
    </SidebarTooltipContainer>
  )
}
